import { render, staticRenderFns } from "./CountryBorn.vue?vue&type=template&id=170bdb19"
import script from "./CountryBorn.vue?vue&type=script&lang=js"
export * from "./CountryBorn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports